import { IElectronicJournalRecord } from 'src/common/interfaces/states/IElectronicJournalRecord';

export const getTotalQuantity = (
  itemId: string | undefined,
  tbrItemsList: IElectronicJournalRecord[],
): number => {
  return tbrItemsList
    .filter(i => (i.tbrScanData || i.ItemId) === itemId)
    .map(item => (item.tbrAvailableQty || 0) - (item.tbrReturnQty || 0))
    .reduce((total, current) => total + current, 0);
};

export const getCheckboxStatus = (item: IElectronicJournalRecord): boolean | undefined => {
  return item.tbrReturnQty === item.tbrAvailableQty
    ? true
    : item.tbrReturnQty === 0
    ? false
    : undefined;
};
